<div class="form-group">
  @if (showLabel && question?.email_version) {
    <label [innerHtml]="question?.email_version" class="form-group__label"></label>
  }

  <input
    type="email"
    [(ngModel)]="value"
    (blur)="saveValue()"
    required
    value=""
    [placeholder]="question?.question_prompt"
    class="form-control"
    id="emailAddress"
    name="emailAddress">


    @if (!valid) {
      <p class="form-control-error">
        <svg class="icon">
          <use xlink:href="#warning-filled"></use>
        </svg>
        Invalid email address.
      </p>
    }

  </div>



